import "./Popular.scss";
import checkbadge from "../../assets/checkbadge.png";
import popular1 from "../../assets/popular1.png";
import popular2 from "../../assets/popular2.png";
import popular3 from "../../assets/popular3.png";
import popular4 from "../../assets/popular4.png";
import popular5 from "../../assets/popular5.png";
import popular6 from "../../assets/popular6.png";
import popular7 from "../../assets/popular7.png";
import popular8 from "../../assets/popular8.png";
import popular9 from "../../assets/popular9.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Popular() {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1.15,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          // variableWidth: true
        },
      },
    ],
  };

  const cardContent = [
    {
      image: popular1,
      title: "Tether Tron",
     hasMore: true,
      listContent: [
        "One of the most popular stablecoins, pegged 1:1 with USD",
        "Runs on Tron, offering near-zero fees and instant transfers",
        "Favored by traders and businesses for quick settlements",
      ],
    },
    {
      image: popular2,
      title: "Tether Polygon",
     hasMore: true,
      listContent: [
        "Combines USD stability with Polygon’s scalable, low-cost network",
        "Perfect for DeFi users, cross-border payments, and micro-transactions",
        "Backed by reserves, ensuring transparency and user trust",
      ],
    },
    {
      image: popular3,
      title: "Tether  Avalanche ",
      hasMore: false,
      listContent: [
        "Stablecoin designed for Avalanche’s ultra-fast ecosystem",
        "Enables seamless participation in DeFi, NFTs, and dApps",
        "Provides reliable USD stability for global Avalanche users",
      ],
    },
    {
      image: popular4,
      title: "Tether Ethereum",
     hasMore: false,
      listContent: [
        "The most widely recognized and integrated stablecoin network",
        "Essential for DeFi liquidity, trading, and global transfers",
        "Secure and highly liquid, trusted across every major exchange",
      ],
    },
    {
      image: popular5,
      title: "Polkadot",
     hasMore: false,
       listContent: [
        "Aims to connect blockchains for seamless interoperability",
        "Designed for cross-chain asset and data transfers",
        "Supports innovation in Web3 by linking diverse ecosystems",
      ],
    },
    {
      image: popular6,
      title: "Polygon",
     hasMore: false,
      isBCH: true,
      listContent: [
        "Brings Ethereum-level security with faster, cheaper transactions",
        "Supports thousands of dApps across gaming, DeFi, and NFTs",
        "Widely adopted by developers and enterprises for scalability",
      ],
    },
     {
      image: popular7,
      title: "Ethereum",
      hasMore: false,
      isBCH: true,
      listContent: [
        "The backbone of smart contracts, DeFi, and NFTs",
        "Offers unmatched developer activity and innovation",
        "A cornerstone for Web3, powering countless blockchain projects",
      ],
    },
     {
      image: popular8,
      title: "Trxcoin",
      hasMore: false,
      isBCH: true,
      listContent: [
        "Optimized for fast, high-volume blockchain transactions",
        "Popular for USDT transfers due to ultra-low fees",
        "Supports entertainment apps, DeFi, and Web3 development",
      ],
    },
     {
      image: popular9,
      title: "Litecoin",
      hasMore: false,
      isBCH: true,
      listContent: [
        "A reliable, time-tested alternative to Bitcoin",
        "Offers faster block times and cheaper transactions",
        "Trusted for everyday payments with global acceptance",
      ],
    },
  ];

  const renderCard = (card, index) => (
    <div key={index} className="card">
      <div className="top">
        <div className="image">
          <img src={card.image} alt="error" />
        </div>
        <div className="content">
          <h1>
            {card.title}{" "}
         </h1>
        </div>
      </div>
      <ul>
        {card.listContent.map((item, idx) => (
          <li key={idx}>
            <img src={checkbadge} alt="error" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="popular spacing">
      <h2>Most Popular Coins Businesses Trust</h2>
      <div className="cards-wrapper">
        <div className="cards">
          {cardContent.map((card, index) => renderCard(card, index))}
        </div>
        <div className="cards-carousel">
          <Slider {...carouselSettings}>
            {cardContent.map((card, index) => renderCard(card, index))}
          </Slider>
        </div>
      </div>
      {/* <p>
        And other 300+ coins <span>Check available currencies</span>
      </p> */}
    </div>
  );
}
